/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_RevenueInputs */

const en_admin_funnel_col_revenue = /** @type {(inputs: Admin_Funnel_Col_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue`)
};

/**
* | output |
* | --- |
* | "Revenue" |
*
* @param {Admin_Funnel_Col_RevenueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_revenue = /** @type {((inputs?: Admin_Funnel_Col_RevenueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_RevenueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_revenue(inputs)
});
export { admin_funnel_col_revenue as "admin.funnel.col.revenue" }